import { IconBaseProps, IconType } from "@/types/icon";

export const CheckOutlineIcon: IconType = ({
  size = 24,
  color = "text-gray-800",
  ...props
}: IconBaseProps) => {
  return (
    <svg
      className={`${color}`}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.10364 15C7.88604 15.0009 7.67673 14.9089 7.52049 14.7437L3.585 10.5775C3.50656 10.4939 3.44397 10.3943 3.40081 10.2844C3.35764 10.1745 3.33475 10.0563 3.33343 9.93674C3.33078 9.69522 3.41617 9.46244 3.57084 9.28961C3.7255 9.11678 3.93676 9.01806 4.15814 9.01516C4.37953 9.01226 4.5929 9.10543 4.75132 9.27416L8.10698 12.8251L15.2482 5.25881C15.4068 5.09007 15.6204 4.99701 15.8419 5.00007C16.0635 5.00314 16.2748 5.1021 16.4295 5.27517C16.5841 5.44824 16.6695 5.68125 16.6666 5.92294C16.6638 6.16463 16.5731 6.3952 16.4145 6.56393L8.6868 14.7437C8.53056 14.9089 8.32125 15.0009 8.10364 15Z"
        fill="#1C304A"
        fill-opacity="0.52"
      />
    </svg>
  );
};
